import React, { useState, useEffect } from 'react';
import { Star } from 'lucide-react';

const clampCount = (n) => {
  const v = Number(n);
  if (!Number.isFinite(v)) return 1;
  return Math.max(1, Math.min(10, Math.round(v)));
};

const RatingElement = ({
  element,
  isEditor = false,
  canInteract = true,
  onRate,
  syncedRating = null
}) => {
  const { content = {} } = element;
  const count = clampCount(content.count ?? 1);
  const starColor = content.starColor || '#eab308';
  const outlineColor = content.outlineColor || starColor;
  const strokeWidth = content.strokeWidth ?? 2;

  const [rating, setRating] = useState(Number(content.rating) || 0);

  useEffect(() => {
    if (syncedRating !== null && syncedRating !== undefined) {
      setRating(Math.max(0, Math.min(count, Number(syncedRating) || 0)));
    }
  }, [syncedRating, count]);

  const handleClick = (index, e) => {
    if (isEditor || !canInteract) return;
    e.stopPropagation();
    const next = index + 1;
    const finalValue = rating === next ? 0 : next;
    setRating(finalValue);
    if (onRate) onRate(finalValue);
  };

  const shown = isEditor ? Math.max(0, Math.min(count, Number(content.rating) || 0)) : rating;

  return (
    <div
      className="w-full h-full flex items-center justify-center"
      style={{ gap: '4%' }}
    >
      {Array.from({ length: count }).map((_, i) => {
        const filled = i < shown;
        return (
          <div
            key={i}
            onClick={(e) => handleClick(i, e)}
            className="h-full flex items-center justify-center"
            style={{
              flex: '1 1 0',
              minWidth: 0,
              cursor: canInteract && !isEditor ? 'pointer' : 'default'
            }}
          >
            <Star
              strokeWidth={strokeWidth}
              style={{
                width: '100%',
                height: '100%',
                color: outlineColor,
                fill: filled ? starColor : 'transparent',
                transition: 'fill 0.15s ease'
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default RatingElement;
